import { email, helpers, required } from 'vuelidate/lib/validators'
import {
  GenericEmailValidation,
  GenericRequiredValidation,
  passwordErrorMessages,
  passwordValidation,
  confirmPasswordValidation
} from '@locaweb/design-system-vue'

const domainRegex = helpers.regex('alpha', /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/)
const tituloRegex = helpers.regex('alpha', /^[ 0-9a-zA-Zàèìòùáéíóúâêîôûãõ\b@\b-\b-\b.\b ]+$/)
const userRegex = helpers.regex('alpha', /^[ 0-9a-zA-Zàèìòùáéíóúâêîôûãõ\b@\b.\b-]+$/)

class Site {
  get model () {
    return {
      domain: '',
      title: '',
      email: '',
      user: ''
    }
  }

  get validations () {
    return {
      site: {
        domain: {
          required: true,
          regex: domainRegex
        },
        title: { required, regex: tituloRegex },
        email: {
          required,
          email
        },
        user: { required, regex: userRegex }
      },
      password: passwordValidation({ minLength: 8, maxLength: 20 }),
      passwordToConfirm: passwordValidation({ minLength: 8, maxLength: 20 }),
      passwordConfirmation: confirmPasswordValidation('passwordToConfirm'),
      transfer: ['site.title', 'site.email', 'site.user', 'site.password'],
      create: ['site.domain', 'site.title', 'site.email', 'site.user', 'site.password']
    }
  }

  get validationsErrors () {
    return {
      domainErrors () {
        let errors = []
        if (this.statusDomainCheck === 422) {
          errors = this.messageErrorDomain
          this.domainStatusCheck = false
        } else {
          errors = errors.concat(GenericRequiredValidation(this.$v.site.domain))
          this.$v.site.domain.required && !this.$v.site.domain.regex && errors.push('Preencha um domínio válido. Ex: dominio.com.br ou dominio.net')
        }
        return errors
      },
      titleErrors () {
        let errors = []
        errors = errors.concat(GenericRequiredValidation(this.$v.site.title))
        this.$v.site.title.required && !this.$v.site.title.regex && errors.push('Não é permitido o uso dos caracteres (",’e /)')
        return errors
      },
      emailErrors () {
        let errors = []
        errors = errors.concat(GenericRequiredValidation(this.$v.site.email))
        errors = errors.concat(GenericEmailValidation(this.$v.site.email))
        return errors
      },
      userErrors () {
        let errors = []
        errors = errors.concat(GenericRequiredValidation(this.$v.site.user))
        this.$v.site.user.required && !this.$v.site.user.regex && errors.push('Não é permitido o uso dos caracteres (",’e /)')
        return errors
      },
      ...passwordErrorMessages('site')
    }
  }
}

export default new Site()
